var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.html)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.formatter(_vm.displayValue))}}):_c('span',[_vm._v(" "+_vm._s(_vm.formatter(_vm.displayValue))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }